import {
  confirmCustomerResponse,
  getCustomerListResponse,
  getRemovedCustomerListResponse,
  removeCustomerResponse,
  unconfirmCustomerResponse,
  updateCustomerResponse,
  updateNationalCustomerResponse,
} from './actions';
import {
  CustomerActionProps,
  CustomerListResponseProps,
  CustomerState,
  RemovedCustomerListResponseProps,
  UpdateCustomerResponseProps,
} from './interface';

import { postConfirmCustomerResponse } from '@state/task/actions';

const initialState: CustomerState = {
  customerList: {
    unconfirmedUsers: [],
    confirmedUsers: [],
    removedUsers: [],
  },
};

const customerReducer = (
  state = initialState,
  action: CustomerActionProps,
): CustomerState => {
  switch (action.type) {
    case String(getCustomerListResponse): {
      const { data } = (action as CustomerListResponseProps).payload;

      return {
        ...state,
        customerList: {
          confirmedUsers: data.confirmedUsers,
          unconfirmedUsers: data.unconfirmedUsers,
          removedUsers: [...state.customerList.removedUsers],
        },
      };
    }

    case String(getRemovedCustomerListResponse): {
      const { data } = (action as RemovedCustomerListResponseProps).payload;

      return {
        ...state,
        customerList: {
          ...state.customerList,
          removedUsers: data,
        },
      };
    }

    case String(postConfirmCustomerResponse):
    case String(confirmCustomerResponse): {
      const { data, id } = action.payload;
      const userId = id ?? data.id;

      const unconfirmedUsers = state.customerList.unconfirmedUsers.filter(
        (unconfirmedUser) => unconfirmedUser.id !== userId,
      );

      const userToUpdate = state.customerList.unconfirmedUsers.find(
        (unconfirmedUser) => unconfirmedUser.id === userId,
      );

      const confirmedUsers = [
        ...state.customerList.confirmedUsers,
        { ...userToUpdate, ...data },
      ];
      const removedUsers = [...state.customerList.removedUsers];

      return {
        ...state,
        customerList: {
          confirmedUsers,
          unconfirmedUsers,
          removedUsers,
        },
      };
    }

    case String(unconfirmCustomerResponse): {
      const { data: user } = (action as UpdateCustomerResponseProps).payload;
      const unconfirmedUsers = [user, ...state.customerList.unconfirmedUsers];
      const confirmedUsers = state.customerList.confirmedUsers.filter(
        (confirmedUser) => confirmedUser.id !== user.id,
      );
      const removedUsers = [...state.customerList.removedUsers];

      return {
        ...state,
        customerList: {
          confirmedUsers,
          unconfirmedUsers,
          removedUsers,
        },
      };
    }

    case String(updateNationalCustomerResponse):
    case String(updateCustomerResponse): {
      const { data, id } = action.payload;
      const userId = id ?? data.id;
      const unconfirmedUsers = [...state.customerList.unconfirmedUsers];
      const confirmedUsers = state.customerList.confirmedUsers.map(
        (confirmedUser) => {
          if (confirmedUser.id === userId)
            return {
              ...confirmedUser,
              ...data,
            };

          return confirmedUser;
        },
      );
      const removedUsers = [...state.customerList.removedUsers];

      return {
        ...state,
        customerList: {
          confirmedUsers,
          unconfirmedUsers,
          removedUsers,
        },
      };
    }

    case String(removeCustomerResponse): {
      const { data: user } = (action as UpdateCustomerResponseProps).payload;
      const unconfirmedUsers = state.customerList.unconfirmedUsers.filter(
        (unconfirmedUser) => unconfirmedUser.id !== user.id,
      );
      const confirmedUsers = [...state.customerList.confirmedUsers];
      const removedUsers = [user, ...state.customerList.removedUsers];

      return {
        ...state,
        customerList: {
          confirmedUsers,
          unconfirmedUsers,
          removedUsers,
        },
      };
    }

    default:
      return state;
  }
};

export default customerReducer;
